module.exports = __webpack_public_path__ + "img/account_300.3b9752d9.jpg";